import { NotificationType } from '../enums';
import { Type } from '@angular/core';
import {
  CreateGroupComponent,
  PushAchievementsComponent,
  PushAlertsComponent,
  PushCollectPointsComponent,
  PushCommentsPenaltiesComponent,
  PushInvitePlayersComponent,
  PushLineupsComponent,
  PushReferralComponent
} from '../../components/action-push';

type PushComponentType =
  | PushCollectPointsComponent
  | PushReferralComponent
  | PushAchievementsComponent
  | PushAlertsComponent
  | PushCommentsPenaltiesComponent
  | PushLineupsComponent
  | CreateGroupComponent
  | PushInvitePlayersComponent;

export const actionPushComponentsMapper: Record<string, Type<PushComponentType>> = {
  [NotificationType.ActionPushPlayerCollectPoints]: PushCollectPointsComponent,
  [NotificationType.ActionPushPlayerInvitePlayers]: PushReferralComponent,
  // [NotificationType.ActionPushPlayerInactive]: redirect games list,
  [NotificationType.ActionPushPlayerAchievements]: PushAchievementsComponent,
  // [NotificationType.ActionPushPlayerInactive2]: redirect games list,
  [NotificationType.ActionPushPlayerAlerts]: PushAlertsComponent,
  [NotificationType.ActionPushPlayerCommentsAndPenalties]: PushCommentsPenaltiesComponent,
  [NotificationType.ActionPushHostCollectPoints]: PushCollectPointsComponent,
  [NotificationType.ActionPushHostInvitePlayers]: PushReferralComponent,
  // [NotificationType.ActionPushHostInactive]: redirect create games,
  [NotificationType.ActionPushHostAchievements]: PushAchievementsComponent,
  [NotificationType.ActionPushHostTeamsDrawing]: PushLineupsComponent,
  [NotificationType.ActionPushHostCommentsAndPenalties]: PushCommentsPenaltiesComponent,
  [NotificationType.ActionPushHostCreateGroup]: CreateGroupComponent,
  [NotificationType.ActionPushHostInvitePreviousPlayers]: PushInvitePlayersComponent
};
